/**
 * What the Coverage pill's tabs share (BAR-3097, BAR-3098): open cases on the tab's tracks,
 * Financing & approval or Ready to schedule in Pre-procedure (BAR-3107), narrowed by its payor,
 * Step, Location and Status filters.
 */

import { PATIENT_FILTER_TAG_SYSTEMS } from '@bariendo/lib/constants';
import { Meta } from '@medplum/fhirtypes';
import { patientFilterClauses, QUEUE_FILTER_ANY, QueueFilterValues } from './queueFilters';
import { OPEN_CASE_CLAUSE } from './readyToScheduleScope';

/** The tabs have no PN or Payment track filter, so neither is applied, whatever the defaults hold. */
export function coverageTabValues(values: QueueFilterValues): QueueFilterValues {
  return { ...values, pn: QUEUE_FILTER_ANY, track: QUEUE_FILTER_ANY };
}

export const trackTagClause = (track: string): string => `_tag eq "${PATIENT_FILTER_TAG_SYSTEMS.track}|${track}"`;

/** An open case, any of `tracks`, the tab's own `clauses`, then the shared filters. */
export function buildCoverageFilter(tracks: string[], clauses: string[], values: QueueFilterValues): string {
  return `(${[
    OPEN_CASE_CLAUSE,
    `(${tracks.map(trackTagClause).join(' or ')})`,
    ...clauses,
    ...patientFilterClauses(coverageTabValues(values), ''),
  ].join(' and ')})`;
}

export function tagCodes(patient: { meta?: Meta } | undefined, system: string): string[] {
  return (patient?.meta?.tag ?? []).filter((tag) => tag.system === system).map((tag) => tag.code ?? '');
}
